const pow3 = (obj) => obj * obj * obj;
export default pow3;
